import { render, staticRenderFns } from "./OptVerification.vue?vue&type=template&id=1fc1b28b&"
import script from "./OptVerification.vue?vue&type=script&lang=js&"
export * from "./OptVerification.vue?vue&type=script&lang=js&"
import style0 from "./OptVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports